import {useQuery} from "@tanstack/react-query";

import useMe from "@/src/modules/core/hooks/use-me";
import {shiftsService} from "@/src/modules/shifts/services";

const REFRESH_INTERVAL = 1000 * 60 * 15; // 15 minutes

export function useActiveShift() {
  const {data: me, isSuccess: isMeReady} = useMe();
  const isShiftsEnabledForRole =
    isMeReady && shiftsService.getIsShiftsEnabledForRole(me);

  const query = useQuery({
    queryKey: ["active-shift"],
    queryFn: () => shiftsService.getActiveShift(),
    enabled: isShiftsEnabledForRole,
    refetchOnWindowFocus: true,
    staleTime: 0,
    gcTime: 0,
    refetchInterval: REFRESH_INTERVAL,
  });

  const {isPending, data, isSuccess, ...rest} = query;
  const shift = data?.shift ?? null;

  return {
    ...rest,
    shift,
    isPending: isPending && isShiftsEnabledForRole,
    /** True after the first successful GET for this role (use to gate UI that depends on fresh shift shape). */
    isSuccess: isSuccess && isShiftsEnabledForRole,
  };
}
